import { useTranslation } from '@/app/components/translations/Translation.tsx';
import React, { useContext } from 'react';
import type { CustomPillElementProps } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import Pill from '@/app/common/components/Pill';
import { useSearchDealsPageData } from '@/app/components/search/searchDealsPageProvider.tsx';
import { ViewMode } from '@/app/common/viewModeUtils.ts';
import { SearchPageContext } from '@/app/components/search/components/SearchPageContainer/SearchPageContext.ts';
import { MaskIcon } from '@/app/common/icons/MaskIcon';

export const ViewModePill = ({ isLoading, busy }: CustomPillElementProps) => {
  const { handleViewModeSwitch } = useSearchDealsPageData();
  const { listView } = useContext(SearchPageContext);
  const { t } = useTranslation();
  const viewMode = listView ? ViewMode.LIST : ViewMode.MAP;
  const viewMap = viewMode === ViewMode.LIST;
  const label = viewMap ? (
    <>
      <MaskIcon category="Location" name="icon-map" size={16} footprint={[17, 16]} />
      {t('vacation.oss.map.view_map_short')}
    </>
  ) : (
    t('vacation.oss.map.view_list')
  );

  return (
    <Pill
      isLoading={isLoading}
      busy={busy}
      label={label}
      handleClick={handleViewModeSwitch}
      showArrow={false}
      selected={false}
      isOpen={false}
      className="pill pill-view-mode"
    />
  );
};
